import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { type Income } from "@/hooks/admin/shared/useIncome";

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import IncomeRow from "@/components/v2/molecules/admin/tabs/AdminIncomeTab/IncomeRow";

interface IncomeTableProps {
  incomes: Income[];
  onEdit: (income: Income) => void;
  onDelete: (income: Income) => void;
  canEdit: boolean;
  canDelete: boolean;
  selectedIncomes: string[];
  onSelectIncome: (incomeId: string, index: number, shiftKey: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

const IncomeTable = ({
  incomes,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  selectedIncomes,
  onSelectIncome,
  onSelectAll,
}: IncomeTableProps) => {
  const showActions = canEdit || canDelete;

  const allSelected = incomes.length > 0 && selectedIncomes.length === incomes.length;
  const someSelected = selectedIncomes.length > 0 && selectedIncomes.length < incomes.length;

  const handleSelectAll = (checked: boolean) => {
    onSelectAll(checked);
  };

  const tableHeaders = [
    "",
    "Reservación",
    "Propiedad",
    "Tipo de ingreso",
    "Tipo de pago",
    "Pago bruto",
    "IVA",
    "Ret IVA",
    "Ret ISR",
    "Comisión",
    "Pago recibido",
    "Fecha de pago",
    "Req. Factura",
    ...(showActions ? ["Acciones"] : []),
  ];

  return (
    <Card>
      <div className="overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {tableHeaders.map((header, index) => (
                <TableHead key={index}>
                  {index === 0 ? (
                    <Checkbox
                      checked={allSelected}
                      onCheckedChange={handleSelectAll}
                      aria-label="Seleccionar todos"
                      className={someSelected ? "data-[state=checked]:bg-primary/80" : ""}
                    />
                  ) : (
                    header
                  )}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {incomes.map((income, index) => (
              <IncomeRow
                key={income.id}
                income={income}
                index={index}
                onEdit={onEdit}
                onDelete={onDelete}
                canEdit={canEdit}
                canDelete={canDelete}
                isSelected={selectedIncomes.includes(income.id)}
                onSelect={onSelectIncome}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default IncomeTable;
